import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import RefinementList from "./refinementList";

const MenuMobile = (props) => {
  const [isVisible, setVisible] = useState(props.visible);

  useEffect(() => {
    setVisible(props.visible);

    if (typeof window !== "undefined")
      document.body.classList.toggle("overflow-hidden", props.visible);

    return () => {
      return false;
    };
  }, [props.visible]);

  const overlay_class = classNames("overlayMenu", {
    show: isVisible,
  });

  const menu_class = classNames(
    "cbp-spmenu cbp-spmenu-vertical cbp-spmenu-right",
    {
      "cbp-spmenu-open": isVisible,
    }
  );

  return (
    <>
      <div
        className={overlay_class}
        onClick={() => props.setMenuIsVisible(false)}
      />
      <div className={menu_class}>
        <div className="p-4 flex flex-col bg-white h-full">
          <div className="flex-1 overflow-y-auto mb-4">
            <div className="flex justify-end bg-white items-center pb-4">
              <button onClick={() => props.setMenuIsVisible(false)}>
                <span className="icon-times text-xl" />
              </button>
            </div>
            <RefinementList
              attribute="permalink.category"
              searchable={false}
              limit={50}
              limited={false}
              setMenuIsVisible={props.setMenuIsVisible}
            />
          </div>
        </div>
      </div>
    </>
  );
};

MenuMobile.propTypes = {
  visible: PropTypes.bool.isRequired,
  setMenuIsVisible: PropTypes.func.isRequired,
};

export default MenuMobile;
